import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import { default as OverdueBillsList } from './OverdueBillsList.react.js';
import OverdueBillDetail from './OverdueBillDetail.react.js';
import * as BrowserPermission from '../../BrowserPermission';
import * as Permission from '../../../common/util/Permission';

class OverdueBillsPage extends React.Component {
    static propTypes = {
        params: PropTypes.object,
        relay: PropTypes.object,
        user: PropTypes.object,
    };
    constructor(props) {
        super(props);
        this.state = { selected: null };
    }

    componentDidMount() {
        try {
            const orgId = this.props.params && (this.props.params.id || this.props.params.organisationId);
            if (orgId && this.props.relay) {
                this.props.relay.setVariables({ organisationId: orgId });
            }
        } catch (e) {}
    }

    componentDidUpdate(prevProps) {
        try {
            const prevOrg = prevProps.params && (prevProps.params.id || prevProps.params.organisationId);
            const orgId = this.props.params && (this.props.params.id || this.props.params.organisationId);
            if (orgId && orgId !== prevOrg && this.props.relay) {
                this.props.relay.setVariables({ organisationId: orgId });
            }
        } catch (e) {}
    }

    render() {
        // build selected bill with logs from Relay (organisation scope)
        let selectedBill = this.state.selected;
        const organisationId = this.props.params && (this.props.params.id || this.props.params.organisationId);
        const isDeveloper = organisationId
            ? (BrowserPermission.hasOrganisationPermission(Permission.PERM_DEVELOPER, organisationId) && BrowserPermission.developerModeEnabled(organisationId))
            : false;
        const isPartner2 = organisationId ? BrowserPermission.isPartner2(organisationId) : false;
        const isPartner1 = organisationId ? BrowserPermission.isPartner1(organisationId) : false;
        const canSeeCommunications = !!(isDeveloper || isPartner1 || isPartner2);
        try {
            const org = this.props.user && this.props.user.organisation;
            const billNode = org && org.organisationOverdueBill;
            const edges = billNode && billNode.logs && billNode.logs.edges;
            const selectedLogsAll = Array.isArray(edges) ? edges.map(e => e && e.node).filter(Boolean) : [];
            const communications = selectedLogsAll.map(l => l && l.communication).filter(Boolean);
            const selectedLogs = selectedLogsAll.filter(l => !(l && (l.type === 'communication' || l.communication)));
            if (selectedBill) {
                selectedBill = { ...selectedBill, logs: selectedLogs, communications };
            }
        } catch (e) {}
        const showDetail = !!(isDeveloper || isPartner1 || isPartner2);
        const listColClass = showDetail ? "col-sm-7" : "col-sm-12";
        return (
            <div className="row">
                <div className={listColClass}>
                    <OverdueBillsList
                        onRefresh={() => {
                            try {
                                const orgId = this.props.params && (this.props.params.id || this.props.params.organisationId);
                                if (this.props.relay) {
                                    this.props.relay.forceFetch({ organisationId: orgId, timestamp: String(Date.now()) });
                                }
                            } catch (e) {}
                        }}
                        onSelect={(item) => {
                            this.setState({ selected: item });
                            try {
                                const selId = item && (item.realId || item.id);
                                if (selId && this.props.relay) {
                                    this.props.relay.setVariables({ selectedBillId: selId, hasSelected: true });
                                }
                            } catch (e) {}
                        }}
                        organisationId={this.props.params && (this.props.params.id || this.props.params.organisationId)}
                        user={this.props.user}
                    />
                </div>
                {showDetail ? (
                    <div className="col-sm-5">
                        <OverdueBillDetail bill={selectedBill} isDeveloper={isDeveloper} canSeeCommunications={canSeeCommunications} onClear={() => {
                            this.setState({ selected: null });
                            try {
                                if (this.props.relay) this.props.relay.setVariables({ hasSelected: false, selectedBillId: '' });
                            } catch (e) {}
                        }} />
                    </div>
                ) : null}
            </div>
        );
    }
}

export default Relay.createContainer(OverdueBillsPage, {
    initialVariables: {
        organisationId: '',
        first: 50,
        timestamp: '',
        selectedBillId: '',
        hasSelected: false,
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    organisationOverdueBills(first: $first, timestamp: $timestamp) {
                        edges { node { id, realId, code, variableSymbol, dueDate, totalAmount, amountToPay, currencyCode, isIgnored } }
                    }
                    organisationOverdueBill(id: $selectedBillId) @include(if: $hasSelected) {
                        id,
                        logs(first: 20, orderBy: "timestamp desc") {
                            edges { node { id, timestamp, title, message, type, communication { id, type, timestamp, message, recipient } } }
                        }
                    }
                }
            }
        `,
    },
});


